module.exports = __webpack_public_path__ + "img/RobotNameTest.1e53e7d0.png";